import React, { useState } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Modal from "react-modal"

import * as styles from "../styles/drawer.module.css"

const Drawer = () => {
  Modal.setAppElement("#___gatsby")

  const [drawerModalOpen, setDrawerModalOpen] = useState(false)

  const toggleDrawerModal = () => {
    setDrawerModalOpen(prevState => !prevState)
  }

  const [catMenuOpen, setCatMenuOpen] = useState(false)

  const toggleCatHandler = () => {
    setCatMenuOpen(prevState => !prevState)
  }

  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        group(field: { frontmatter: { categories: { slug: SELECT } } }) {
          fieldValue
        }
      }
      allCategoryJson {
        nodes {
          slug
          title
        }
      }
    }
  `)

  return (
    <>
      <button
        className={`${styles.navbtn} ${styles.navbtnBars}`}
        onClick={toggleDrawerModal}
        aria-label="メニューボタン"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="32px"
          viewBox="0 0 24 24"
          width="32px"
          fill="var(--colorDark)"
        >
          <path d="M0 0h24v24H0V0z" fill="none"></path>
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
        </svg>
        <span className="sr-only">MENU</span>
      </button>
      <Modal
        closeTimeoutMS={300}
        isOpen={drawerModalOpen}
        onRequestClose={toggleDrawerModal}
        contentLabel="Drawer Modal"
        overlayClassName={styles.overlay}
        className={styles.overlayInner}
        style={
          catMenuOpen
            ? { content: { overflowY: "scroll" } }
            : { content: { overflowY: "hidden" } }
        }
      >
        <button
          className={`${styles.navbtn} ${styles.navbtnXmark}`}
          onClick={toggleDrawerModal}
          aria-label="メニューを閉じる"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="32px"
            viewBox="0 0 24 24"
            width="32px"
            fill="var(--colorWhite)"
          >
            <path d="M0 0h24v24H0V0z" fill="none"></path>
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
          </svg>
        </button>
        <ul className={styles.drawerList}>
          <li>
            <Link to="/" className={styles.drawerItem}>
              HOME
            </Link>
          </li>
          <li>
            <Link to="/about/" className={styles.drawerItem}>
              ABOUT
            </Link>
          </li>
          <li>
            <button
              href="#"
              className={styles.drawerItem}
              onClick={toggleCatHandler}
              type="button"
              aria-expanded={catMenuOpen}
              aria-controls="category"
            >
              CATEGORY
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="var(--colorWhite)"
                className={
                  catMenuOpen
                    ? `${styles.catIcon} ${styles.rotate}`
                    : styles.catIcon
                }
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
              </svg>
            </button>
            {catMenuOpen && (
              <ul className={styles.drawerChildList} id="category">
                {data.allMarkdownRemark.group.map(category => (
                  <li key={category.fieldValue}>
                    <Link
                      to={`/category/${category.fieldValue}/`}
                      className={styles.drawerItem}
                    >
                      {
                        data.allCategoryJson.nodes.filter(
                          catJson => catJson.slug === category.fieldValue,
                        )[0].title
                      }
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>
      </Modal>
    </>
  )
}

export default Drawer
